module.exports = __webpack_public_path__ + "static/media/dnd.31a48d83.svg";